import generateCrudEndpoints from '@packages/toolbox/dist/utils/endpoint-generator';

import { SERVER_API } from 'SharedDir/constants/app/endpoints';
import { IEndpointData } from 'SharedDir/declarations/shared';

export const REGISTRY_MATERIAL_RESOURCE_URL = `${SERVER_API}/registry-material-resource`;
export const REGISTRY_MATERIAL_RESOURCE_STATUS_URL = `${SERVER_API}/registry-material-resource-status`;

export const REGISTRY_MATERIAL_RESOURCE = {
  ...generateCrudEndpoints(REGISTRY_MATERIAL_RESOURCE_URL),
  AVAILABLE_STATUSES: {
    method: 'GET',
    url: `${REGISTRY_MATERIAL_RESOURCE_STATUS_URL}/acceptable-changes`,
  } as IEndpointData,
  HISTORY(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${REGISTRY_MATERIAL_RESOURCE_URL}/${id.toString()}/history`,
    };
  },
  PROVIDED(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${REGISTRY_MATERIAL_RESOURCE_URL}/${id.toString()}/provided`,
    };
  },
  MESSAGE(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${REGISTRY_MATERIAL_RESOURCE_URL}/${id.toString()}/message`,
    };
  },
  SEND_MESSAGE(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${REGISTRY_MATERIAL_RESOURCE_URL}/${id.toString()}/send-notification`,
    };
  },
  EXPORT_TABLE_IN_BACKGROUND: {
    method: 'POST',
    url: `${REGISTRY_MATERIAL_RESOURCE_URL}/export-task`,
  },
};

export const REGISTRY_MATERIAL_RESOURCE_NPA_URL = `${SERVER_API}/regulatory-legal-act`;

export const REGISTRY_MATERIAL_RESOURCE_NPA = {
  ...generateCrudEndpoints(REGISTRY_MATERIAL_RESOURCE_NPA_URL),
  HISTORY(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${REGISTRY_MATERIAL_RESOURCE_NPA_URL}/${id.toString()}/history`,
    };
  },
  HISTORY_ACT(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${REGISTRY_MATERIAL_RESOURCE_NPA_URL}/${id.toString()}/history/registry_act`,
    };
  },
  GENERATE_ACT(id: number | string): IEndpointData {
    return {
      method: 'POST',
      url: `${REGISTRY_MATERIAL_RESOURCE_NPA_URL}/${id.toString()}/generate`,
    };
  },
  RETRY_EGISSO(id: number) {
    return {
      method: 'POST',
      url: `${REGISTRY_MATERIAL_RESOURCE_NPA_URL}/${id.toString()}/egisso/retry`,
    };
  },
};

export const DECREE_GSM_URL = `${SERVER_API}/decree-gsm`;
export const DECREE_GSM = {
  ...generateCrudEndpoints(DECREE_GSM_URL),
  HISTORY(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${DECREE_GSM_URL}/${id.toString()}/history`,
    };
  },
  HISTORY_TO_PAYMENT(id: number): IEndpointData {
    return {
      method: 'GET',
      url: `${DECREE_GSM_URL}/${id.toString()}/history/to-payment`,
    };
  },
  PROVIDE_PAYMENTS(id: number | string): IEndpointData {
    return {
      method: 'POST',
      url: `${DECREE_GSM_URL}/${id.toString()}/generate`,
    };
  },
  EXPORT_PAYMENTS_XLSX(id: number | string): IEndpointData {
    return {
      method: 'POST',
      url: `${DECREE_GSM_URL}/${id.toString()}/export/payments`,
    };
  },
  EXPORT_PERSONS_XLSX(id: number | string): IEndpointData {
    return {
      method: 'POST',
      url: `${DECREE_GSM_URL}/${id.toString()}/export/persons`,
    };
  },
  EXPORT_XML(id: number | string): IEndpointData {
    return {
      method: 'GET',
      url: `${DECREE_GSM_URL}/${id.toString()}/xml-export`,
    };
  },
};

export const egissoUrl = `${SERVER_API}/material-resources/egisso/settings`;

export const cashPaymentsUrl = `${SERVER_API}/material-resources/cash-payments`;

export const EGISSO = {
  ...generateCrudEndpoints(egissoUrl),
};

export const egissoRequestsUrl = `${SERVER_API}/material-resources/egisso/requests`;

export const EGISSO_REQUESTS = {
  CANCEL(id: number): IEndpointData {
    return {
      method: 'POST',
      url: `${egissoRequestsUrl}/${id.toString()}/cancel`,
    };
  },
};
